"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _style = require("./style");

var _chartTitle = _interopRequireDefault(require("../chart-title"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var Chart = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../chart"));
  });
});

var SelectChart = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../select-chart"));
  });
});

var Legend = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../legend"));
  });
});

var Standalone = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../standalone"));
  });
});

var Map = _react["default"].lazy(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("@widget-editor/map"));
  });
});

var Renderer = function Renderer(_ref) {
  var widget = _ref.widget,
      editor = _ref.editor,
      _ref$widgetConfig = _ref.widgetConfig,
      widgetConfig = _ref$widgetConfig === void 0 ? null : _ref$widgetConfig,
      _ref$standalone = _ref.standalone,
      standalone = _ref$standalone === void 0 ? true : _ref$standalone,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? null : _ref$theme,
      _ref$thumbnail = _ref.thumbnail,
      thumbnail = _ref$thumbnail === void 0 ? false : _ref$thumbnail,
      configuration = _ref.configuration,
      compact = _ref.compact,
      changeBbox = _ref.changeBbox,
      interactionEnabled = _ref.interactionEnabled,
      widgetName = _ref.widgetName;
  var restoring = editor.restoring,
      initialized = editor.initialized;
  var missingWidget = initialized && !restoring && widget && Object.keys(widget).length === 0;
  var isMap = configuration.visualizationType === "map";

  if (restoring) {
    return _react["default"].createElement(_style.StyledContainer, null, _react["default"].createElement(_style.RestoringWidget, null, _react["default"].createElement(_style.RestoringWidgetTitle, null, "Loading widget...")));
  }

  if (standalone) {
    return _react["default"].createElement(_react.Suspense, {
      fallback: _react["default"].createElement(_style.RestoringWidget, null, _react["default"].createElement(_style.RestoringWidgetTitle, null, "Loading widget..."))
    }, _react["default"].createElement(Standalone, {
      thumbnail: thumbnail,
      widgetConfig: widgetConfig,
      widgetName: widgetName,
      theme: theme,
      changeBbox: changeBbox,
      interactionEnabled: interactionEnabled
    }));
  }

  return _react["default"].createElement(_style.StyledContainer, {
    compact: compact
  }, !widgetConfig && initialized && _react["default"].createElement(_react.Suspense, {
    fallback: _react["default"].createElement("div", null, "Loading...")
  }, _react["default"].createElement(SelectChart, {
    advanced: editor.advanced
  })), initialized && !restoring && !isMap && _react["default"].createElement(_react.Suspense, {
    fallback: _react["default"].createElement(_style.RestoringWidget, null, _react["default"].createElement(_style.RestoringWidgetTitle, null, "Loading widget..."))
  }, _react["default"].createElement(_chartTitle["default"], {
    configuration: configuration
  }), _react["default"].createElement(Chart, {
    advanced: editor.advanced,
    compact: compact,
    widgetConfig: widgetConfig
  })), initialized && !restoring && isMap && _react["default"].createElement(_react.Suspense, {
    fallback: _react["default"].createElement("div", null, "Loading...")
  }, !!editor.layers && _react["default"].createElement(Map, {
    mapConfiguration: configuration.map,
    caption: configuration.title,
    layerId: configuration.layer,
    interactionEnabled: !standalone,
    layers: editor.layers,
    changeBbox: changeBbox
  })), !initialized && !missingWidget && _react["default"].createElement(_style.RestoringWidget, null, _react["default"].createElement(_style.RestoringWidgetTitle, null, "Loading widget...")), restoring && !missingWidget && _react["default"].createElement(_style.RestoringWidget, null, _react["default"].createElement(_style.RestoringWidgetTitle, null, "Building widget...")), !widgetConfig && !isMap && _react["default"].createElement(_react.Suspense, {
    fallback: _react["default"].createElement("div", null, "Loading...")
  }, _react["default"].createElement(Legend, {
    compact: compact
  })));
};

var _default = Renderer;
exports["default"] = _default;